import React, { useCallback, useEffect, useState } from "react";
import { listMetrics, getAllMetrics } from "services/MetricService";
import { Center, Spinner } from "@chakra-ui/react";
import showToast from "hooks/useCustomToast";
import { Header, MetricProto } from "build-ts/metadata";
import KnowledgeGraphVisualizer from "../components/KnowledgeGraphVisualizer";
import { useConfigurationContext } from "context/ConfigurationContext";

interface KnowledgeGraphVisualizerContainerProps {
  shouldReload?: boolean; // When this is true, it triggers a reload
}

const KnowledgeGraphVisualizerContainer: React.FC<KnowledgeGraphVisualizerContainerProps> = ({ shouldReload }) => {
  const { setMetricList } = useConfigurationContext();
  const [metricInfoMap, setMetricInfoMap] = useState<Map<string, MetricProto>>(new Map());
  const [loading, setLoading] = useState<boolean>(true);
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const headers = await listMetrics("" /* modelId */);
      setMetricList(headers);

      if (headers?.length) {
        const metricIds = headers.map((h: Header) => h.id!);
        const metricInfoArray = await getAllMetrics(metricIds, true);
        const dataMap = new Map<string, MetricProto>();
        metricInfoArray.forEach(m => {
          if (m.header?.id) dataMap.set(m.header.id, m);
        });
        setMetricInfoMap(dataMap);
      }
    } catch (error) {
      showToast("Error fetching data", "", "error");
    } finally {
      setLoading(false);
    }
  }, [setMetricList]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (shouldReload) {
      setMetricInfoMap(new Map());
      fetchData();
    }
  }, [shouldReload, fetchData]);

  return (
    <>
      {loading ? (
        // Render a loader while loading is true
        <Center h="100vh">
          <Spinner size="xl" color="#purple.700" />
        </Center>
      ) : (
        <KnowledgeGraphVisualizer metricInfoMap={metricInfoMap} />
      )}
    </>
  );
};

export default KnowledgeGraphVisualizerContainer;
